(() => {
  const header = document.querySelector('[data-np-header]');
  if (!header) return;
  const menu = header.querySelector('[data-np-mobile-menu]');
  const overlay = header.querySelector('[data-np-mobile-overlay]');
  const openBtn = header.querySelector('[data-np-mobile-open]');
  const closeBtn = header.querySelector('[data-np-mobile-close]');
  const setMobile = (open) => {
    menu.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    openBtn.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('np-menu-open', open);
  };
  openBtn?.addEventListener('click', () => setMobile(true));
  closeBtn?.addEventListener('click', () => setMobile(false));
  overlay?.addEventListener('click', () => setMobile(false));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') setMobile(false); });

  // Close mobile drawer when opening search
  header.addEventListener('click', (e) => {
    if (e.target.closest('[data-np-open-search]')) {
      setMobile(false);
    }
  });

  header.querySelectorAll('[data-np-mega-button]').forEach(button => {
    button.addEventListener('click', () => {
      const panel = button.parentElement.querySelector('[data-np-mega]');
      const willOpen = !panel.classList.contains('is-open');
      header.querySelectorAll('[data-np-mega]').forEach(item => item.classList.remove('is-open'));
      header.querySelectorAll('[data-np-mega-button]').forEach(item => item.setAttribute('aria-expanded','false'));
      panel.classList.toggle('is-open', willOpen);
      button.setAttribute('aria-expanded', String(willOpen));
    });
  });
  let compact = false;
  window.addEventListener('scroll', () => {
    const next = window.scrollY > 80;
    if (next !== compact) { compact = next; header.classList.toggle('is-compact', compact); }
  }, {passive:true});
})();